import {Dialog, DialogBackdrop, DialogPanel, DialogTitle, Switch} from "@headlessui/react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/free-solid-svg-icons";
import {DateTimePickerInput} from "../../Form/DateTimePickerInput";
import {PrimaryButton} from "../../Buttons/PrimaryButton";
import * as React from "react";
import {useTranslation} from "react-i18next";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {useBoundStore} from "../../../Store/store";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import {useEffect} from "react";
import {DangerButton} from "../../Buttons/DangerButton";

export const UpdateAvailabilityDialog = (props) => {
    const {
        open,
        onClose,
        userId,
        availability
    } = props;

    const {t} = useTranslation();

    const updateAvailability = useBoundStore((state) => state.updateAvailability);
    const deleteAvailability = useBoundStore((state) => state.deleteAvailability);

    useEffect(() => {
        if(availability) {
            reset({
                ...availability,
                start_time: dayjs(availability.start_time).format('YYYY-MM-DD HH:mm:ss'),
                end_time: dayjs(availability.end_time).format('YYYY-MM-DD HH:mm:ss'),
            })
        }
    }, [availability]);

    const schema = yup.object({
        start_time: yup.string().required(),
        end_time: yup.string().required(),
    }).required()

    const {
        handleSubmit,
        formState: {errors},
        getValues,
        setValue,
        control,
        reset
    } = useForm({
        resolver: yupResolver(schema),
        reValidateMode: 'onBlur',
        mode: 'onChange',
        defaultValues:{
            customer_id: userId,
            start_time: availability?.start_time,
            end_time: availability?.end_time,
        }
    });

    const onSubmit = (data) => {
        const transformedData = {
            ...data,
            start_time: dayjs(data.start_time).format('YYYY-MM-DD HH:mm:ss'),
            end_time: dayjs(data.end_time).format('YYYY-MM-DD HH:mm:ss'),
        }

        updateAvailability(availability?.id , transformedData)
            .then(() => {
                toast.success(t('availabilities.toast_saved'));
                onClose();
            })
            .catch((error) => {
                console.error('Error creating customer', error);
            })
    }

    return (
        <Dialog className="relative z-50" open={open} onClose={onClose}>
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity duration-500 ease-in-out data-[closed]:opacity-0"
            />

            <div className="fixed inset-0 overflow-visible">
                <div className="absolute inset-0 overflow-visible">
                    <div className="pointer-events-none p-4 rounded-lg fixed inset-y-0 right-0 flex max-w-full">
                        <DialogPanel
                            transition
                            className="pointer-events-auto w-screen max-w-lg transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
                        >
                            <div className="flex h-full rounded-2xl flex-col overflow-visible bg-white py-6 shadow-xl">
                                <div className="px-4 sm:px-6">
                                    <div className="flex items-start justify-between">
                                        <DialogTitle className="text-base font-semibold leading-6 text-gray-900">
                                            {t('availabilities.update_title')}
                                        </DialogTitle>
                                        <div className="ml-3 flex h-7 items-center">
                                            <button
                                                type="button"
                                                className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none"
                                                onClick={() => onClose()}
                                            >
                                                <span className="absolute -inset-2.5" />
                                                <span className="sr-only">Close panel</span>
                                                <FontAwesomeIcon icon={faTimes} className="h-6 w-6" aria-hidden="true" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="relative mt-6 flex-1 px-4 sm:px-6">
                                    <form className="w-full" onSubmit={handleSubmit(onSubmit)}>

                                        <div className={'grid grid-cols-1 md:grid-cols-2 mb-1 md:space-x-4 mb-4'}>
                                            <DateTimePickerInput
                                                label={'Start time'}
                                                name={'start_time'}
                                                setValue={setValue}
                                                control={control}
                                                currentValue={getValues('start_time')}
                                                translationIndex={'general.fields.start_time'}
                                                errors={errors}
                                            />
                                            <DateTimePickerInput
                                                label={'End time'}
                                                name={'end_time'}
                                                setValue={setValue}
                                                control={control}
                                                currentValue={getValues('start_time')}
                                                translationIndex={'general.fields.end_time'}
                                                errors={errors}
                                            />
                                        </div>

                                        <div className={'grid grid-cols-1 md:grid-cols-2 gap-4'}>
                                            <div>
                                                <DangerButton onClick={() => {
                                                    deleteAvailability(availability?.id)
                                                        .then(() => {
                                                            toast.success(t('availabilities.toast_deleted'));
                                                            onClose();
                                                        })
                                                        .catch((error) => {
                                                            console.error('Error creating customer', error);
                                                        })
                                                }}>{t('availabilities.delete_button')}</DangerButton>
                                            </div>

                                            <div>
                                                <PrimaryButton onClick={handleSubmit(onSubmit)}>
                                                    {t('availabilities.save_button')}
                                                </PrimaryButton>
                                            </div>
                                        </div>


                                    </form>
                                </div>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </div>
        </Dialog>
    )
}